module.exports = __webpack_public_path__ + "static/img/ent-83.40c492b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-83.jpg
// module id = kInt
// module chunks = 51